export default __webpack_public_path__ + "static/media/revive.4b7e4dec.mp3";